import debugLog from '@/debug-log-script-name.js'

$(function() {
  const $participants = $('.table--participants')
  debugLog($participants, 'participants.js') // DEBUG
  $participants.each(function() {
    var $table = $(this),
      $nameInputs = $table.find('[name*="Nickname"]')

    if ($nameInputs.length) {
      $nameInputs.on('paste', function(e) {
        var $input = $(this),
          clipboardData = e.originalEvent.clipboardData || window.clipboardData,
          pasteData = clipboardData.getData('text'),
          inputIndex = $nameInputs.index($input)

        if (pasteData) {
          var lines = pasteData.split('\n')
          var firstColumn = []

          lines.forEach(function(line) {
            var split = line.split('\t')

            if (split.length) {
              firstColumn.push(split[0])
            }
          })

          if (firstColumn.length) {
            var $inputs = $nameInputs.slice(inputIndex)

            $inputs.each(function(i) {
              if (firstColumn[i]) {
                $(this).val(firstColumn[i])
              }
            })

            e.preventDefault()
          }
        }
      })
    }
  })
})
